import React, { useState, useEffect, useRef } from 'react'
import { ScrapbookContainer, ScrapbookItem } from '../../../../styles/Homepage/ReviewsSection.style';
import { CardMedia, Typography, useMediaQuery, useTheme } from '@mui/material';
import { PhotoOrReview } from '../../../../interfaces/types';

interface ScrapbookProps {
    items: PhotoOrReview[];
}

const ITEM_SIZE = 200;
const MID_SCREEN_MAX_ITEMS = 8;

const ReviewsSection: React.FC<ScrapbookProps> = ({ items }) => {
    const [gridSize, setGridSize] = useState<number>(0)
    const containerRef = useRef<HTMLDivElement | null>(null)
    const theme = useTheme();
    const isMidScreen = useMediaQuery(theme.breakpoints.down('xl'));

    const displayedItems = isMidScreen ? items.slice(0, MID_SCREEN_MAX_ITEMS) : items;

    useEffect(() => {
        const numItems = displayedItems.length;
        const sqrt = Math.ceil(Math.sqrt(numItems));
        setGridSize(sqrt);
    }, [displayedItems.length]);

    const getRandomGridPosition = (index: number): { top: string; left: string } => {
        const containerWidth = containerRef.current?.offsetWidth || 0;
        const containerHeight = containerRef.current?.offsetHeight || 0;

        const row = Math.floor(index / gridSize);
        const col = index % gridSize;

        const heightOffset = (row < gridSize / 2 ? -0.3 : 0) * containerHeight;
        const widthOffset = (col < gridSize / 3 ? -0.35 : -0.3) * containerWidth;

        const top = row * (ITEM_SIZE + 20) + heightOffset;
        const left = col * (ITEM_SIZE + 40) + widthOffset;
        return { top: `${top}px`, left: `${left}px` };
    };

    return (
            <ScrapbookContainer>
                {displayedItems.map((item, index) => {
                    const randomRotation = Math.floor(Math.random() * 15) - 7;

                    const { top, left } = getRandomGridPosition(index);

                    const zIndex = item.type === 'text' ? 10 : 1;

                    return (
                        <ScrapbookItem
                            key={index}
                            rotation={randomRotation}
                            top={top}
                            left={left}
                            style={{ zIndex }}
                        >
                            {item.type === 'image' ? (
                                <CardMedia component="img" height="200" image={item.image} alt="Souvenir partagé par un client de DJ Mayday" />
                            ) : (
                                <Typography variant="body1">{item.content}</Typography>
                            )}
                        </ScrapbookItem>
                    );
                })}
            </ScrapbookContainer>
    )
}

export default ReviewsSection
